/*
 * Relocate the Vitals reviews carousel.
 *
 * Vitals injects the "Trusted by 10,000+ Kiwis" reviews carousel (mid 21)
 * near the footer via its own placement — the theme's app block renders
 * nothing, and the position isn't reachable from the Vitals dashboard here.
 * This moves the rendered carousel into #vtls-reviews-slot (placed directly
 * under the product / Add to cart in main-product.liquid) once Vitals has
 * built it, then nudges a resize so the carousel re-measures for its new width.
 */
(function () {
  var moved = false;

  function pickWidget() {
    var widgets = document.querySelectorAll('.Vtl-ReviewsCarousel__Widget');
    // Prefer the text-only reviews carousel (not a media/video one).
    for (var i = 0; i < widgets.length; i++) {
      if (widgets[i].querySelector('.Vtl-ReviewsCarousel--TextOnlyCards')) return widgets[i];
    }
    return widgets[0] || null;
  }

  function tryMove() {
    if (moved) return true;
    var slot = document.getElementById('vtls-reviews-slot');
    if (!slot) return true; // not a page with the slot — nothing to do
    var widget = pickWidget();
    if (!widget) return false; // Vitals hasn't rendered it yet
    if (!slot.contains(widget)) {
      slot.appendChild(widget);
      window.dispatchEvent(new Event('resize'));
    }
    moved = true;
    return true;
  }

  if (tryMove()) return;
  var tries = 0;
  var iv = setInterval(function () {
    tries += 1;
    if (tryMove() || tries > 40) clearInterval(iv); // give up after ~10s
  }, 250);
})();
